<template>
  <div>
    <confirm-modal
      :title="confirmModalData.title"
      :confirm-button="confirmModalData.confirmButton"
    >
      {{ confirmModalData.text }}
    </confirm-modal>
    <congrats-modal
      :coins="coins.coins"
      :points="coins.points"
      :description="coins.description"
    ></congrats-modal>
    <div id="todolist" class="mt-2">
      <ul
        class="list-group d-flex justify-content-center items-align-center mb-5 pb-4"
      >
        <!-- List of items -->
        <li
          v-for="item in checks"
          :class="
            item.qualifiedParent
              ? item.approvedParent
                ? 'check-item-accepted'
                : 'check-item-denied'
              : item.approvedChild
              ? 'check-item-pending'
              : 'check-item-none'
          "
          :key="item.id"
          class=" list-group-item d-flex justify-content-between align-items-center py-3 px-3"
        >
          <div
            class="d-flex flex-grow-1 justify-content-start align-items-center"
          >
            <!-- Coins Data -->
            <div
              class="coinContainer d-flex gap-1 justify-content-center align-items-center mr-2"
              :class="{ userIsAParent: 'flex-grow-1' }"
            >
              <img :src="require(`@/assets/coin.png`)" class="" />
              <span v-if="!userIsAParent" class="coinTextStyle">
                {{ item.coin_value }}
              </span>

              <!-- Change Value of  Coins -->
              <div
                v-else
                class="d-flex align-items-center ml-1"
                :class="{ userIsAParent: 'flex-grow-1' }"
              >
                <input
                  type="number"
                  class="atm-input coinInput flex-grow-1"
                  v-model="item.coin_value"
                />
              </div>
            </div>

            <!-- Check Item Data -->
            <section
              class="label mx-3"
              :class="{ userIsAParent: 'flex-grow-1' }"
            >
              <span
                v-if="!userIsAParent"
                class="font-normal"
                :class="item.qualifiedParent ? 'text-light' : 'text-dark'"
              >
                {{ item.description }}
              </span>
              <input
                v-else
                type="text"
                class="atm-input w-100"
                v-model="item.description"
              />
            </section>
          </div>

          <!--  Check if child -->
          <div
            v-if="!userIsAParent"
            class="checkboxStyle d-flex justify-content-center align-items-center  material-icons-round unselectable"
            :class="
              item.qualifiedParent
                ? item.approvedParent
                  ? 'check-text-accepted cursor-default'
                  : 'check-text-denied cursor-default'
                : item.approvedChild
                ? 'check-text-accepted cursor-pointer'
                : 'cursor-pointer'
            "
            @click="
              showInputChild(item.approvedChild, item.qualifiedParent)
                ? markAsDoneOrUndone(item)
                : ''
            "
          >
            {{
              item.qualifiedParent
                ? item.approvedParent
                  ? 'done'
                  : 'close'
                : item.approvedChild
                ? 'done'
                : ''
            }}
          </div>
          <b-button
            v-show="
              item.defaultValue != item.coin_value ||
                item.defaultDescription !== item.description
            "
            class="verifyUpdate p-0"
            @click="changeItemData(item)"
          >
            <i class="material-icons align-middle">check</i>
          </b-button>
          <!-- Delete item if parent -->
          <b-col
            v-if="userIsAParent"
            cols="1"
            class="actions p-0 text-center"
            align-self="center"
          >
            <i
              class="material-icons-round align-middle cursor color-main"
              @click="showMsgDelete(item)"
              >delete_outline</i
            >
          </b-col>
        </li>
      </ul>
    </div>
    <!-- Button Done (child) -->
    <b-row
      v-if="!userIsAParent"
      class="d-none justify-content-center align-items-center w-100"
      :class="{ 'd-flex': showButton }"
    >
      <button class="atm-button bg-main w-50" @click="childDoneAction">
        Save
      </button>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import confirmModal from '@/common/components/modal/ConfirmModal';
import CongratsModal from '@/components/Congrats/CongratsModal.vue';

export default {
  components: {
    confirmModal,
    CongratsModal
  },
  props: {
    module: { type: Object, required: true },
    checklist: { type: Array, required: true },
    date: { type: String, required: false }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  data: function() {
    return {
      checks: [],
      showButton: false,
      requestSent: false,
      confirmModalData: {
        title: 'Confirm',
        text: 'text',
        confirmButton: () => {}
      },
      coins: {
        description: '',
        coins: 0,
        points: 0
      }
    };
  },
  methods: {
    ...mapActions('checklist', [
      'setChildCheckValues',
      'updateCoinValues',
      'updateCriteria',
      'DeleteCriterion'
    ]),
    showInputChild(child, parent) {
      if (!this.userIsAParent) {
        if (parent) {
          return false;
        } else {
          if (this.buttonActive) {
            if (child) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    markAsDoneOrUndone: function(item) {
      if (!item.defChild) {
        item.approvedChild = !item.approvedChild;
      }
      this.showButton = false;
      this.checks.forEach(element => {
        if (element.defChild != element.approvedChild) {
          this.showButton = true;
        }
      });
    },

    changeItemData(item) {
      if (item.description !== item.defaultDescription) {
        this.updateCriteria({
          itemId: item.id,
          itemDescription: item.description,
          itemValue: item.coin_value
        });
      } else if (item.defaultValue !== item.coin_value) {
        this.updateCoinValues({
          id: item.id,
          coin_value: item.coin_value
        }).then(() => {
          item.defaultValue = item.coin_value;
        });
      }
      this.recalculeDefaults(item);
    },

    showMsgDelete(item) {
      this.boxTwo = '';
      this.$bvModal
        .msgBoxConfirm('Do you want to delete this criterion?', {
          title: '',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-1',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.boxTwo = value;
          if (value) {
            this.DeleteCriterion({
              itemId: item.id,
              order: this.module.module.order
            }).then(() => {
              this.recalculeDefaults();
              this.$parent.calculeCriterion();
            });
          }
        })
        .catch(err => {
          console.log('atmCriterionList', err);
        });
    },

    recalculeDefaults(item = null) {
      this.checks = [];
      this.checklist.forEach(element => {
        const itemDataObject = element.checklist_item;
        
        if (itemDataObject) {
          element = { id: element.id, name: element.name, ...itemDataObject };
        }

        element.defaultDescription = element.description;
        element.defaultValue = element.coin_value;
        this.checks.push(element);
      });
    },

    async childDoneAction() {
      if (!this.requestSent) {
        try {
          this.requestSent = true;
          const data = await this.setChildCheckValues({
            items: this.checks,
            date: this.date
          });
          this.requestSent = false;
          this.coins['coins'] = data['coins'];
          this.coins['points'] = data['points'];
          this.coins['description'] = data['description'];
          this.$bvModal.show('congrats-modal');
        } catch (error) {
          console.log(error);
        }
        //do if correct
        // this.$router.replace({
        //   name: 'congrats',
        //   params: {
        //     coins: response.coins,
        //     points: response.points,
        //     description: response.description
        //   },
        //   query: { next: 'checklist' }
        // });
      }
    },
    handleCloseModalCoins() {
      const toRedirect = this.fromCalendar
        ? 'calendar'
        : this.isProject
        ? 'projects'
        : 'tasks';
      this.$router.push(toRedirect);
    }
  },
  computed: {
    ...mapGetters('user', ['userIsAParent'])
  },
  mounted() {
    this.recalculeDefaults();
  }
};
</script>

<style lang="scss" scoped>
#todolist .label {
  position: relative;
  transition: opacity 0.2s linear;
}
#todolist .done .label {
  opacity: 1;
}

ul {
  gap: 1rem;
}

li {
  min-height: 72px;
  border-radius: 0.8rem !important;
}
.checkboxStyle {
  font-weight: 600;
  position: relative;
  display: inline-block;
  background-color: #ffffff;
  min-width: 32px;
  height: 32px;
  padding: 0px;
  border-radius: 8px;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
}

.coinContainer {
  position: relative;
  & > img {
    width: 40px;
  }

  .coinTextStyle {
    position: absolute;
    font-size: 0.8rem;
    font-weight: 600;
  }

  .coinInput {
    text-align: center;
    width: 50px;
  }
}

.verifyUpdate {
  background: var(--color-main);
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  box-shadow: 2px 2px 6px rgb(0 0 0 / 25%);
}

.gap-1 {
  gap: 0.3rem;
}

.font-normal {
  font-weight: 600;
}

.check-item-none {
  background-color: #f3f3f3;
}

.check-item-pending {
  background-color: #bef3d3;
}

.check-item-accepted {
  background-color: #5de192;
}

.check-item-denied {
  background-color: #ff5569;
}

.check-text-accepted {
  color: #5de192;
  cursor: default;
}
.check-text-denied {
  color: #ff5569;
  cursor: default;
}

.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}

.unselectable {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  -ms-user-select: none;
  user-select: none;
}
</style>
